
const mutations = {
  TOGGLE_MENU(state, value) {
    state.showMenu = value;
  },
  TOGGLE_LOADING(state, value) {
    state.loading = value;
  },
};

const actions = {
  toggleMenu({ commit }, value) {
    if (typeof value === 'boolean') {
      commit('TOGGLE_MENU', value);
    }
  },
  toggleLoading: {
    root: true,
    handler: function toggleLoading({ commit }, value) {
      commit('TOGGLE_LOADING', value);
    },
  },
};

const getters = {
  showMobileMenu(state) {
    return state.showMenu;
  },
  isLoading(state) {
    return state.loading;
  },
};

const state = {
  showMenu: false,
  loading: false,
};

const store = {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};

export default store;
